<div class="chart-pag">

  <div (click)="goToPrevSlide()">
    <svg viewBox="0 0 24 24">
      <use [attr.xlink:href]="'assets/icons/arrow_left.svg#svg1'"></use>
    </svg>
  </div>

  <div *ngFor="let page of pages; let idx = index;"
       (click)="goToSlide(idx)">
    <svg viewBox="0 0 512 512"
         [class.active]="pagIdx === idx"
         [matTooltip]="page"
         matTooltipClass="bg-primary">
      <use [attr.xlink:href]="'assets/icons/hexagon.svg#svg1'"></use>
    </svg>
  </div>

  <div (click)="goToNextSlide()">
    <svg viewBox="0 0 24 24">
      <use [attr.xlink:href]="'assets/icons/arrow_right.svg#svg1'"></use>
    </svg>
  </div>

</div>
